import React from 'react';
import { IClientAttributeModel } from '../../../../../../../Types/ClientModelTypes';
import { getChecklistValuesAndLabels } from '../../../../../Utils/urvalUtils';
import EDCheckbox from '../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import { equals, append, remove } from 'ramda';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  attribute: IClientAttributeModel;
  condition: string[];
  setCondition: (newCondition: string[]) => void;
  isSmallScreen: boolean;
  disabled: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: { display: 'flex', flexWrap: 'wrap' },
});

class ChecklistConditionValues extends React.Component<IProps> {
  handleCheckboxChange = (label: string) => () => {
    const index = this.props.condition.findIndex(equals(label));

    if (index === -1) {
      this.props.setCondition(append(label, this.props.condition));
    } else {
      this.props.setCondition(remove(index, 1, this.props.condition));
    }
  };

  render() {
    const { attribute, condition, classes, disabled } = this.props;
    const checkboxValuesAndLabels = getChecklistValuesAndLabels(attribute);

    return (
      <div className={classes.root}>
        {checkboxValuesAndLabels.map((valueAndLabel, index) => (
          <EDBox
            sx={{ width: { xs: '100%', sm: '50%' }, display: 'flex' }}
            key={valueAndLabel.value}
          >
            <EDCheckbox
              key={valueAndLabel.value}
              label={valueAndLabel.displayLabel}
              checked={condition.includes(valueAndLabel.value)}
              onCheck={this.handleCheckboxChange(valueAndLabel.value)}
              testId={index.toString()}
              disabled={disabled}
            />
          </EDBox>
        ))}
      </div>
    );
  }
}

export default withStyles(ChecklistConditionValues, styles);
